/**
 * Display label for a skill or tool key, looked up in the given option lists
 * (state.SkillsAndTools.skillOptions / toolOptions).
 *
 * Returns the option's translation; the key itself when the lists have loaded
 * but don't know it (legacy keys); and null while the lists are still empty,
 * so callers leave the item out instead of flashing the raw key until the
 * browser's fetch returns (client-side navigation from a page that didn't
 * load them).
 *
 * @param {string} key
 * @param {Array<Array<object>>} optionLists
 * @param {'fiTranslation'|'enTranslation'} translationKey
 * @returns {string|null}
 */
export const skillOrToolLabel = (key, optionLists, translationKey) => {
  for (const options of optionLists) {
    const label = options.find(o => o && o.key === key)?.[translationKey];
    if (label) {
      return label;
    }
  }
  const loaded = optionLists.every(options => options.length > 0);
  return loaded ? key : null;
};
